import CONSTANTS from "core/constants";
import { t } from "i18next";
import { getTemplateTranslationKey } from "helpers/templates";
import { Template } from "../types";

export const getTemplateLabel = (
  template: Template | null,
  templates: Template[],
  showRevisitLabelSuffix: boolean,
  fullPsySchedule = false,
) => {
  const placeholderLabel = "*Unknown*";
  if (!template) return placeholderLabel;
  const templateNameKey = getTemplateTranslationKey(template.name);

  // If there is a duplicate templateId UI shows the time in parentheses after the template translation
  const isDuplicate =
    templates.filter(
      (comparedTemplate) => comparedTemplate.templateId === template.templateId,
    ).length > 1;

  const lengthInMin = template.defaultLength;
  const minuteSuffix = ` (${lengthInMin})`;

  let suffix = "";
  if (
    showRevisitLabelSuffix &&
    template.name === CONSTANTS.REVISIT &&
    !fullPsySchedule
  ) {
    suffix = t("REVISIT_LABEL_INFO_SUFFIX");
  } else if (isDuplicate) {
    suffix = minuteSuffix;
  }

  return `${t(templateNameKey, placeholderLabel)}${suffix}`;
};
